import TextButton from 'components/Luxkit/Button/TextButton'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

const ErrorButton = styled(TextButton)`
  margin-top: ${rem(32)};
`

function AwesomeErrorButton({ onClick, children }) {
  return <ErrorButton kind="primary" onClick={onClick}>
    {children}
  </ErrorButton>
}

export default AwesomeErrorButton
